import { render, staticRenderFns } from "./GrowUp.vue?vue&type=template&id=e6e6d25a&scoped=true&"
import script from "./GrowUp.vue?vue&type=script&lang=js&"
export * from "./GrowUp.vue?vue&type=script&lang=js&"
import style0 from "./GrowUp.vue?vue&type=style&index=0&id=e6e6d25a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e6d25a",
  null
  
)

export default component.exports